// import { mapGetters } from "vuex";
// import { mapGetters } from "vuex";

export default {
  data() {
    return {
      // eslint-disable-next-line
      timeCycleBusinessProcessOptions: [
        "Qtr",
        "Half",
        "Annual",
        "Long Term"
      ],
      // eslint-disable-next-line
      timePlanProcessOptions: [
        "Live",
        "Weekly",
        "Monthly",
        "120D",
        "Major"
      ],
      // eslint-disable-next-line
      timeDecisionOptions: [
        "Live",
        "Perm",
        "Temp"
      ],
      // eslint-disable-next-line
      plantLifeOptions: [
        "1",
        "2",
        "3",
        "4",
        "5",
        "10",
        "15",
        "20",
        "25",
        "30",
        "35",
        "40",
        "50"
      ],
      // eslint-disable-next-line
      activityCycleOptions: [
        "1W",
        "2W",
        "1M",
        "2M",
        "3M",
        "6M",
        "9M",
        "1Y"
      ],
      // eslint-disable-next-line
      leadTimeOptions: [
        "1D",
        "3D",
        "1W",
        "2W",
        "1M",
        "3M",
        "6M",
        "9M",
        "1Y",
        "2Y"
      ]
    };
  }
};
